import { Component } from '@angular/core';
import { TrelloService } from 'app/trello/services/trello.service';

@Component({
  selector: 'app-card-details-component',
  templateUrl: './card-details.component.html',
})
export class CardDetailsComponent {

  constructor(
    private readonly trelloService: TrelloService, // required
  ) {
  }

}
